import { render, staticRenderFns } from "./Card1.vue?vue&type=template&id=4e2ab693&scoped=true"
import script from "./Card1.vue?vue&type=script&lang=js"
export * from "./Card1.vue?vue&type=script&lang=js"
import style0 from "./Card1.vue?vue&type=style&index=0&id=4e2ab693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2ab693",
  null
  
)

export default component.exports